export default __webpack_public_path__ + "static/media/Private-5g_Bg-Loop.eb3eda16.mp4";